import React, {useEffect} from "react";
import DefaultCSS from "./resource/DefaultCSS";
import Studio from "./pages/Studio";
import {fetchAxiosGet} from "./helper/axiosPost";
import {mp3UrlAtom} from "./states/timeline";
import {initializeState, initializeUrlState} from "./states/initialize";
import {useAtom} from "jotai";
import {AIcaptionListState, AITransServiceListState, captionListState, latestSavedCaptionAtom} from "./states/caption";
import {CaptionListProps} from "./types/caption";
import {timeStringToSeconds} from './helper/util'
import axios from "axios";
import z from 'zod'

const initializerType = z.object({
  job_id: z.string(),
  user_id: z.string(),
  start_time: z.string(),
  end_time: z.string(),
  video_title: z.string(),
  video_language: z.string(),
  video_url: z.string(),
  audio_url: z.string(),
  srt_url: z.string(),
  duration: z.string(),
  text_limit: z.string(),
  caption_min_time: z.string(),
  caption_max_time: z.string(),
  supported_trans_service: z.array(
    z.object({
      trans_srt_id: z.string(),
      trans_port: z.string(),
      trans_path: z.string(),
      trans_service: z.string(),
      trans_url: z.string(),

    })
  )
})

/**
 App.tsx (기본 CSS 설정, initialize, studio 불러오기)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

//  function timeStringToSeconds(timeString : string) {
//   const totalMilliseconds = Date.parse(`1970-01-01T${timeString.replace(',', ".")}Z`);
//   const totalSeconds = totalMilliseconds / 1000;
//   return totalSeconds
// }

function SetInitialize() {

  const [{
    initialTransUrl,
    initialCaptionUrl,
    initialCaptionReferenceUrl,
    defaultCaptionUrl
  }] = useAtom(initializeUrlState);
  const [, setInitialize] = useAtom(initializeState);
  const [, setCaptionList] = useAtom(captionListState);
  const [, setAICaptionList] = useAtom(AIcaptionListState);
  const [, setAITransServiceList] = useAtom(AITransServiceListState);

  const [, setMp3Url] = useAtom(mp3UrlAtom)
  const [latestSavedCaption] = useAtom(latestSavedCaptionAtom);

  // useEffect(() => {
  //   // 데이터 받아오기
  //   fetchAxiosGet(initialTransUrl)
  //   .then((data) => {
  //       setInitialize(data.result);
  //       setMp3Url(data.result.audio_url)

  useEffect(() => {
    // 데이터 받아오기
    fetchAxiosGet(initialTransUrl).then((data) => {
      const initializeObj = initializerType.parse(data.result)

      setInitialize({
        ...initializeObj,
        caption_max_time: parseFloat(initializeObj.caption_max_time),
        caption_min_time: parseFloat(initializeObj.caption_min_time),
        text_limit: parseInt(initializeObj.text_limit),
        duration: parseFloat(initializeObj.duration)
      });

      setMp3Url(data.result.audio_url)
      setAITransServiceList(data.result.supported_trans_service);
    });


    fetchAxiosGet(initialCaptionReferenceUrl)
      .then((data) => {
        if (data && Array.isArray(data)) {

          const dummySegment: CaptionListProps = {
            caption: " ",
            seq: 0,
            time_end: "00:00:00.000",
            time_ini: "00:00:00.000",
            startTime: 0,
            endTime: 0,
            labelText: '_',
            color: "#ff0000",
            // id: uuidv4() ,
            // id: String(segment.seq) ,
            id: '0',
            editable: true
          }

          const newData = data.map((segment, index) => {
            const obj: CaptionListProps = {
              ...segment,
              // seq : String(segment.seq),
              seq: Number(index + 1),
              startTime: timeStringToSeconds(segment.time_ini),
              endTime: timeStringToSeconds(segment.time_end),
              labelText: segment.caption,
              color: "#ff0000",
              id: String(index + 1),
              // id: String(Math.random()),
              editable: true
            }
            return obj
          })

          const newDataForState = [dummySegment].concat(newData)
          latestSavedCaption.current = structuredClone(newDataForState)
          setAICaptionList(newDataForState);
          // setCaptionList(data);

        } else {

          axios.get(defaultCaptionUrl).then((rr) => {


            const dummySegment: CaptionListProps = {
              caption: " ",
              seq: 0,
              time_end: "00:00:00.000",
              time_ini: "00:00:00.000",
              startTime: 0,
              endTime: 0,
              labelText: '_',
              color: "#ff0000",
              // id: uuidv4() ,
              // id: String(segment.seq) ,
              id: '0',
              editable: true
            }


            const newData = rr.data.map((segment: any, index: any) => {
              const obj: CaptionListProps = {
                ...segment,
                // seq : String(segment.seq),
                seq: Number(index + 1),
                startTime: timeStringToSeconds(segment.time_ini),
                endTime: timeStringToSeconds(segment.time_end),
                labelText: segment.caption,
                color: "#ff0000",
                id: String(index + 1),
                // id: String(Math.random()),
                editable: true
              }
              return obj
            })

            const newDataForState = [dummySegment].concat(newData)
            latestSavedCaption.current = structuredClone(newDataForState)
            setAICaptionList(newDataForState);

          })
          //alert("작업 아이디 로드 에러. CMS 작업 내용을 다시 확인해주세요");

        }
      });


    fetchAxiosGet(initialCaptionUrl)
      .then((data) => {

        if (data && Array.isArray(data)) {

          const dummySegment: CaptionListProps = {
            caption: " ",
            seq: 0,
            time_end: "00:00:00.000",
            time_ini: "00:00:00.000",
            startTime: 0,
            endTime: 0,
            labelText: '_',
            color: "#ff0000",
            // id: uuidv4() ,
            // id: String(segment.seq) ,
            id: '0',
            editable: true
          }

          const newData = data.map((segment, index) => {
            const obj: CaptionListProps = {
              ...segment,
              // seq : String(segment.seq),
              seq: Number(index + 1),
              startTime: timeStringToSeconds(segment.time_ini),
              endTime: timeStringToSeconds(segment.time_end),
              labelText: segment.caption,
              color: "#ff0000",
              id: String(index + 1),
              // id: String(Math.random()),
              editable: true
            }
            return obj
          })

          const newDataForState = [dummySegment].concat(newData)
          latestSavedCaption.current = structuredClone(newDataForState)
          setCaptionList(newDataForState);
          // setCaptionList(data);

        } else {

          axios.get(defaultCaptionUrl).then((rr) => {


            const dummySegment: CaptionListProps = {
              caption: " ",
              seq: 0,
              time_end: "00:00:00.000",
              time_ini: "00:00:00.000",
              startTime: 0,
              endTime: 0,
              labelText: '_',
              color: "#ff0000",
              // id: uuidv4() ,
              // id: String(segment.seq) ,
              id: '0',
              editable: true
            }


            const newData = rr.data.map((segment: any, index: any) => {
              const obj: CaptionListProps = {
                ...segment,
                // seq : String(segment.seq),
                seq: Number(index + 1),
                startTime: timeStringToSeconds(segment.time_ini),
                endTime: timeStringToSeconds(segment.time_end),
                labelText: segment.caption,
                color: "#ff0000",
                id: String(index + 1),
                // id: String(Math.random()),
                editable: true
              }
              return obj
            })

            const newDataForState = [dummySegment].concat(newData)
            latestSavedCaption.current = structuredClone(newDataForState)
            setCaptionList(newDataForState);

          })
          //alert("작업 아이디 로드 에러. CMS 작업 내용을 다시 확인해주세요");

        }
      });


  }, []);

  return (
    <>
    </>
  );

}


export default function App() {
  return (
    <>
      {/* <ChakraProvider> */}
      <DefaultCSS/>
      <SetInitialize/>
      <Studio/>
      {/* </ChakraProvider> */}

    </>
  );
}
